/**
 * Read the full bytes of a picked File, with a friendly rejection for
 * cloud-app "virtual" files (Google Drive on Android serves file objects
 * with valid name/type whose byte reads fail with ERR_NETWORK).
 *
 * Returns the ArrayBuffer on success, or null if the file cannot be read
 * (caller should show the download-to-device guidance).
 */
export async function readFileBytes(file: File): Promise<ArrayBuffer | null> {
  try {
    // Small probe first (cheap; fails fast on virtual files).
    await file.slice(0, 1).arrayBuffer();
    return await file.arrayBuffer();
  } catch {
    return null;
  }
}

export const CLOUD_FILE_ERROR =
  'This file is stored in a cloud app (e.g. Google Drive) and can\'t be read from your device. Download it to the phone first (long-press in the app > Download), then pick it from Files and retry.';
